import Vue from "vue";

const CharacterLength = () =>
  import(/* webpackPrefetch: true */ "./CharacterLength.vue");
Vue.component("character-length", CharacterLength);
